"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VStack = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("./core");
var Fluid_1 = require("./Fluid");
function VStack(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    // The empty div is a guard against styles from other layout components leaking inside when nested
    // There's a story for that: FluidRows
    var styledVStack = (react_1.default.createElement("div", null,
        react_1.default.createElement(StyledVStack, __assign({}, props),
            react_1.default.createElement(MarginRemover, null),
            children)));
    // The Fluid wrapper makes sure the VStack will take 100% of the parent height
    return props.full ? react_1.default.createElement(Fluid_1.Fluid, null, styledVStack) : styledVStack;
}
exports.VStack = VStack;
var StyledVStack = core_1.styled('div', {
    '--flexBasis': 'auto',
    '--flexFr': 0,
    '--space': 'space.$none',
    '--spaceMultiplier': 1,
    'alignItems': 'stretch',
    'display': 'flex',
    'flexDirection': 'column',
    'minHeight': '100%',
    '> *': {
        flex: 'var(--flexFr) var(--flexFr) var(--flexBasis)',
        marginTop: 'calc(var(--space) * var(--spaceMultiplier))',
        minHeight: 0,
        position: 'relative',
    },
}, {
    align: {
        center: { alignItems: 'center' },
        left: { alignItems: 'flex-start' },
        right: { alignItems: 'flex-end' },
    },
    alignY: {
        bottom: { justifyContent: 'flex-end' },
        center: { justifyContent: 'center' },
        top: { justifyContent: 'flex-start' },
    },
    full: { true: { height: '$full', width: '$full' } },
    scroll: {
        true: { overflowY: 'auto' },
    },
    space: core_1.mapTokens('space', function (value) { return ({ '--space': value }); }),
});
var MarginRemover = core_1.styled('div', { '--spaceMultiplier': -1 });
